import { getStrapiMedia } from "@repo/lib/utils";
import Image from "next/image";
const PromotionCard = ({
  item
}) => {
  const {
    media
  } = item;
  return <div key={item?.id} className="relative" data-sentry-component="PromotionCard" data-sentry-source-file="PromotionCard.jsx">
      <Image src={getStrapiMedia(media?.url)} alt={media?.alternativeText} width={media?.width} height={media?.height} className="mx-auto rounded-lg" data-sentry-element="Image" data-sentry-source-file="PromotionCard.jsx" />
    </div>;
};
export default PromotionCard;